import './App.css';
import AllRoutes from './component/AllRoutes';

function App() {
  return (
    <div className='App'>
      <AllRoutes />
      
    </div>
  );
}

export default App;
